const FLAT_RESPONSE_DASHBOARD_PATH = /^\/response-dashboard\/([^/]+)\/?$/

/** Old flat path — kept for redirects and parse compatibility. */
const FLAT_LOI_DASHBOARD_LEGACY_PATH = /^\/loi-dashboard\/([^/]+)\/?$/

const LEGACY_LOI_DASHBOARD_PATH =
  /^\/campaigns\/([^/]+)\/loi\/([^/]+)\/response-dashboard\/?$/

export function loiDashboardPath(loiId: string): string {
  return `/response-dashboard/${loiId}`
}

export function parseLoiDashboardPath(
  pathname: string,
): { loiId: string; campaignId?: string } | null {
  const flat = FLAT_RESPONSE_DASHBOARD_PATH.exec(pathname)
  if (flat) return { loiId: flat[1] }

  const legacyFlat = FLAT_LOI_DASHBOARD_LEGACY_PATH.exec(pathname)
  if (legacyFlat) return { loiId: legacyFlat[1] }

  const legacy = LEGACY_LOI_DASHBOARD_PATH.exec(pathname)
  if (legacy) return { campaignId: legacy[1], loiId: legacy[2] }

  return null
}

export function isLoiDashboardPath(pathname: string): boolean {
  return parseLoiDashboardPath(pathname) !== null
}
